export default __webpack_public_path__ + "static/media/img_code.45499a8d.png";